/* eslint-disable react/jsx-no-undef */
import React from 'react'

import Navbar from '../Navbar/Navbar'
import Footer from '../Footer/Footer'
import { Outlet } from 'react-router-dom'

export default function Layout({userData, setUserData}) {
    return (
        <>
            <div>
            <Navbar  userData={userData}  setUserData={setUserData}/>
                <div className="container overflow-hidden" style={{ paddingBottom: "140px" }}>
                <Outlet></Outlet>
                </div>
                <Footer />
            </div>
        </>
    )
}
